import { ICategory } from "../../types/category.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getCategories({
  status = [],
  search = "",

  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = "",
  orderBy = "-updatedAt",
  fields = "name",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }

  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );

  const url = `${API_URL}/categories?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ICategory[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getAllCategories() {
  const params = new URLSearchParams();

  const url = `${API_URL}/categories?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ICategory[]
  >;

  return { ok: result.ok, data: result.data };
}

export async function getCategoriesById(categoryId: string) {
  const url = `${API_URL}/categories/${categoryId}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ICategory>
  >;

  return result;
}

export async function createCategory(data) {
  const url = `${API_URL}/categorie`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ICategory>
  >;
}

export async function updateCategory(data: ICategory) {
  const url = `${API_URL}/categories/${data._id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ICategory>
  >;

  return result;
}
